import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Mail, ArrowLeft, Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const ForgotPasswordPage = () => {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const result = await forgotPassword(email);
    setIsLoading(false);

    if (result.success) {
      setSuccess(true);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#e8f4f8] flex items-center justify-center p-4">
      {/* Decorative circles */}
      <div className="fixed top-0 left-0 w-96 h-96 bg-[#d0e8ef] rounded-full -translate-x-1/2 -translate-y-1/2 opacity-50" />
      <div className="fixed bottom-0 right-0 w-80 h-80 bg-[#d0e8ef] rounded-full translate-x-1/3 translate-y-1/3 opacity-50" />
      
      <div className="relative z-10 w-full max-w-md bg-white rounded-3xl shadow-xl p-8 py-10">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#2d1b4e] to-[#1a1040] flex items-center justify-center shadow-lg overflow-hidden">
            <img 
              src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692cc1ea9c8a6553034e2bc3/40c4882f7_logo.png" 
              alt="Giresun Kent Rehberi" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {!success ? (
          <>
            <h1 className="text-2xl font-bold text-center text-gray-900 mb-2">
              Şifremi Unuttum
            </h1>
            <p className="text-center text-gray-500 mb-8">
              E-posta adresinizi girin, şifre sıfırlama linki gönderelim.
            </p>

            {error && (
              <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-600 text-sm rounded-xl flex items-start gap-3">
                <AlertCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-center text-sm font-medium text-gray-700 mb-2">
                  E-posta
                </label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <Input
                    type="email"
                    placeholder="ornek@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="pl-12 py-3 h-12 rounded-xl border-gray-200 focus:border-[#1e3a5f] focus:ring-[#1e3a5f]"
                  />
                </div>
              </div>

              <Button
                type="submit"
                disabled={isLoading}
                className="w-full h-12 bg-[#1e3a5f] hover:bg-[#2a4a73] text-white font-medium rounded-xl transition-colors duration-200"
              >
                {isLoading ? (
                  <span className="flex items-center gap-2">
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Gönderiliyor...
                  </span>
                ) : (
                  'Sıfırlama Linki Gönder'
                )}
              </Button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-10 h-10 text-green-500" />
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">E-posta Gönderildi!</h2>
            <p className="text-gray-500 mb-6">
              Şifre sıfırlama linki <strong>{email}</strong> adresine gönderildi. 
              Lütfen gelen kutunuzu kontrol edin.
            </p>
            <p className="text-sm text-gray-400">
              E-posta görünmüyorsa spam klasörünü kontrol edin.
            </p>
          </div>
        )}

        <div className="mt-6 text-center">
          <Link 
            to="/login" 
            className="inline-flex items-center gap-2 text-[#1e3a5f] hover:underline font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Giriş sayfasına dön
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
